<section class="flex flex-col items-center justify-center w-full m-auto max-w-640 max-h-720 p-30 md:w-640">
    <!-- <img src="./assets/images/404.svg" class="w-auto m-20 h-300"/> -->
    <div class="flex flex-col justify-center m-20 bg-center bg-no-repeat bg-cover w-300 h-300"
        style="background-image: url('./assets/images/404.svg');">
        <h1 class="-mt-5 font-bold leading-tight text-center text-opacity-50 text-orange-darker" style="font-size: 12rem;">
            404</h1>
    </div>
    <h1 class="m-20 text-lg font-bold text-center sm:text-2xl">Whoops...Page not found...</h1>
    <button class="m-20 button is-primary is-outlined is-lg" routerLink="Portal" mat-button>Return to Home Page</button>
</section>